import { format } from 'date-fns';
import {
  List,
  Datagrid,
  TextField,
  FunctionField,
  DeleteButton,
  BulkDeleteButton,
  Pagination,
} from 'react-admin';
import { Box, Typography } from '@mui/material';
import { FilterSelectInput } from '../../../shared/components/FilterSelectInput';

interface UserEventsListProps {
  userId: string;
}

const UserEventsFilters = [
  <FilterSelectInput
    key="action"
    source="action"
    label="Action"
    choices={[
      { id: 'listen', name: 'Listen' },
      { id: 'skip', name: 'Skip' },
      { id: 'complete', name: 'Complete' },
      { id: 'pause', name: 'Pause' },
      { id: 'replace', name: 'Replace' },
      { id: 'share', name: 'Share' },
    ]}
    alwaysOn
  />,
  <FilterSelectInput
    key="objectType"
    source="objectType"
    label="Object Type"
    choices={[
      { id: 'drop', name: 'Drop (Story)' },
      { id: 'channel', name: 'Channel (Show)' },
    ]}
    alwaysOn
  />,
];

export const UserEventsList = ({ userId }: UserEventsListProps) => {
  return (
    <List
      resource="user_events"
      filter={{ userId }}
      filters={UserEventsFilters}
      perPage={25}
      sort={{ field: 'timestamp', order: 'DESC' }}
      actions={false}
      pagination={<Pagination />}
      sx={{ '& .RaList-content': { boxShadow: 'none' } }}
    >
      <Datagrid
        bulkActionButtons={
          <BulkDeleteButton label="" mutationMode="pessimistic" />
        }
        size="small"
        rowClick={false}
      >
        <FunctionField
          source="timestamp"
          label="Time"
          sortable
          render={(record: any) => {
            if (!record.timestamp) return null;
            const date = new Date(record.timestamp);
            return (
              <Box sx={{ lineHeight: 1.4 }}>
                <div>{format(date, 'yyyy-MM-dd')}</div>
                <div>{format(date, 'HH:mm:ss')}</div>
              </Box>
            );
          }}
        />
        <TextField source="session" label="S#" emptyText="—" />
        <TextField source="objectType" label="Obj Type" />
        <TextField source="action" label="Action" />
        <TextField source="objectSlug" label="Slug" />
        <FunctionField
          source="metadata"
          label="Metadata"
          render={(record: any) => {
            if (!record.metadata || typeof record.metadata !== 'object') {
              return (
                <Typography variant="body2" color="text.secondary">
                  —
                </Typography>
              );
            }

            return (
              <Box
                sx={{
                  fontFamily: 'monospace',
                  fontSize: '0.75rem',
                  lineHeight: 1.6,
                }}
              >
                {Object.entries(record.metadata).map(([key, value]) => (
                  <div key={key}>
                    {key}: {String(value)}
                  </div>
                ))}
              </Box>
            );
          }}
        />
        <DeleteButton label="" mutationMode="pessimistic" />
      </Datagrid>
    </List>
  );
};
